<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <slug-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <title-text />
        </b-col>
        <b-col cols="12">
          <summary-text />
        </b-col>
        <b-col cols="12">
          <content-text />
        </b-col>
      </b-row>
    </b-card>
    <image-card />
<!--    <photo-gallery />-->
    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'

// import BlogCategory from '@/views/Admin/Blog/elements/BlogCategory.vue'
import TitleText from '@/views/Admin/Static_services/elements/Title.vue'
import SlugText from '@/views/Admin/Static_services/elements/Slug.vue'
import SummaryText from '@/views/Admin/Static_services/elements/Summary.vue'
import ContentText from '@/views/Admin/Static_services/elements/Content.vue'
import ImageCard from '@/views/Admin/Static_services/elements/Image.vue'
// import PhotoGallery from '@/views/Admin/Static_services/elements/PhotoGallery.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    // BlogCategory,
    TitleText,
    SummaryText,
    ContentText,
    ImageCard,
    // PhotoGallery,
    SlugText,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['static_services/dataItem']
    },
  },
}
</script>
